// uses  styleguide/notif.less
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import NOTIFICATION_TYPE from '../../enums/NOTIFICATION_TYPE';
import Icon from '../common/Icon';
import { hideNotification, destroyNotification } from './notificationActionCreators';

// depends on values in styleguide/notif.less
const SHOWING_ANIM_TIME_MS = 500;
const HIDING_ANIM_TIME_MS = 500;

const AUTOHIDE_TIME_MS = 3000;

const ICON_ALIAS = {
    [NOTIFICATION_TYPE.SUCCESS]: 'check-circle',
    [NOTIFICATION_TYPE.ERROR]: 'exclamation-triangle',
    [NOTIFICATION_TYPE.INFO]: 'alert-circle-o',
};

class Notification extends React.Component {
    componentDidMount() {
        if (!this.props.persist) {
            this.autohideTimeout = setTimeout(
                this.props.dispatchHideNotification,
                SHOWING_ANIM_TIME_MS + AUTOHIDE_TIME_MS
            );
        }
    }

    UNSAFE_componentWillUpdate(nextProps) {
        if (!this.props.hiding && nextProps.hiding) {
            this.hidingTimeout = setTimeout(this.props.dispatchDestroyNotification, HIDING_ANIM_TIME_MS);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.autohideTimeout);
        clearTimeout(this.hidingTimeout);
    }

    render() {
        return (
            <div className={notificationClassName(this.props.type, this.props.hiding)}>
                {this.props.persist && (
                    <button type="button" className="sg-notif-close" onClick={this.props.dispatchHideNotification}>
                        <Icon alias="times" />
                    </button>
                )}
                <Icon alias={ICON_ALIAS[this.props.type]} />
                <span className="sg-notif-message">{this.props.text}</span>
            </div>
        );
    }
}

Notification.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    persist: PropTypes.bool.isRequired,
    hiding: PropTypes.bool.isRequired,
    dispatchHideNotification: PropTypes.func.isRequired,
    dispatchDestroyNotification: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    dispatchHideNotification: hideNotification,
    dispatchDestroyNotification: destroyNotification,
};

function notificationClassName(type, hiding) {
    let className = `sg-notif sg-notif-${type}`;
    if (hiding) {
        className += ' sg-notif-fadeout';
    }

    return className;
}

function NotificationWrapper(props) {
    return <div className="sg-notifs-container">{props.id && <Notification key={props.id} {...props} />}</div>;
}

NotificationWrapper.propTypes = {
    id: PropTypes.number,
};

export default connect((state) => state.notification, mapDispatchToProps)(NotificationWrapper);
